var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2558 15.9768V19.1861M1 9.55816V22C1 23.1046 1.89543 24 3 24H21C22.1046 24 23 23.1046 23 22V9.55816C20.4419 5.27908 14.3023 1 12.2558 1C9.69768 1 3.55815 5.27908 1 9.55816Z",
    stroke: "white",
    strokeOpacity: 0.27,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeVector);
export default __webpack_public_path__ + "static/media/home-vector.ded46db0d4dd8096dc8813a1c2378201.svg";
export { ForwardRef as ReactComponent };